import { LocalDate } from '../../utilities/local-date';
import type { IssueDeadlineExtension, IssueEscalationCandidate, OverdueIssue } from './issue-escalation';

/**
 * Rene hjelpefunksjoner for å beregne hvilke avvik som er over frist (krav 1.2.1).
 * Et avvik er over frist når det har en frist (`deadline`) som er passert.
 * Holdt adskilt fra typene i issue-escalation.ts.
 */

/** Effektiv frist for et avvik gitt eventuelle ennå ikke lagrede forlengelser. */
function effectiveDeadline(
  candidate: IssueEscalationCandidate,
  pendingExtensions: Record<string, IssueDeadlineExtension>,
): string | undefined {
  return pendingExtensions[candidate.uuid]?.deadline ?? candidate.deadline;
}

/**
 * Avvik som er over frist akkurat nå: har en frist som er passert (før i dag).
 * `pendingExtensions` lar forhåndsvisningen ta hensyn til forlengelser brukeren
 * har lagt inn, men ikke lagret ennå. Sortert med flest dager over frist først.
 */
export function overdueIssues(
  candidates: IssueEscalationCandidate[],
  today: LocalDate,
  pendingExtensions: Record<string, IssueDeadlineExtension> = {},
): OverdueIssue[] {
  return candidates
    .flatMap((c) => {
      const deadline = effectiveDeadline(c, pendingExtensions);
      if (!deadline || !LocalDate.fromString(deadline).isBefore(today)) {
        return [];
      }
      return [{ ...c, deadline, daysOverdue: LocalDate.fromString(deadline).until(today) }];
    })
    .sort((a, b) => b.daysOverdue - a.daysOverdue);
}
